import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import swal from "sweetalert";
import { motion } from "framer-motion";
import Modal from "../../../myfin_v2/elements/Modal";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import commoncss from "../../../myfin_v2/css/common.module.css";
import dropdowncss from "../../../myfin_v2/css/dropdown.module.css";
import InputGroup from "../../../myfin_v2/elements/InputGroup";
import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as DownIcon } from "../../../myfin_v2/assets/icons/down_arrow.svg";
import { ReactComponent as UpIcon } from "../../../myfin_v2/assets/icons/up_arrow.svg";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as CircleCheckIcon } from "../../../myfin_v2/assets/icons/circle_check.svg";
import { ReactComponent as PlusIcon } from "../../../myfin_v2/assets/icons/plusprimary.svg";
import { addTBNote, mapLedger } from '../../Services/ApiHandler';
import {
  updateGroupings,
  updateLedgers,
  getBCTbRows
} from "../../../redux/actions/BookClosure/actionBookClosure";


const card = {
    position: "fixed",
    bottom: "3%",
    right: "2%",
    width: "300px",
    // height:'55px',
    backgroundColor: "white",
    zIndex: "99",
    borderRadius: "2px",
    boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.3)",
    // boxShadow: '5px 10px #888888'
};
const action = {
    borderRadius: "2px",
    height: "50px",
    backgroundColor: "var(--clr-bg)",
    zIndex: "99",
    display: "flex",
    alignItems: "center",
};
const form = {
    borderRadius: "2px",
    height: "170px",
    backgroundColor: "white",
    zIndex: "99",
};

const CustomSelect = ({ value, onChange, placeholder, options, disabled, valueKey, labelKey }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const dropdownRef = React.useRef(null);
    const inputRef = React.useRef(null);

    // Sync input value with selection
    useEffect(() => {
        if (!value) {
            setInputValue("");
        } else {
            const found = options?.find(opt => {
                const val = valueKey === "json" ? JSON.stringify(opt) : (valueKey ? opt[valueKey] : opt);
                return String(val) === String(value);
            });
            if (found) {
                setInputValue(labelKey ? found[labelKey] : found);
            } else {
                try {
                    if (typeof value === "string" && value.startsWith("{")) {
                        const parsed = JSON.parse(value);
                        if (labelKey && parsed[labelKey]) {
                            setInputValue(parsed[labelKey]);
                            return;
                        }
                    }
                } catch (e) {}
                setInputValue(value);
            }
        }
    }, [value, options, labelKey, valueKey]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
                // Revert input text back to the selected label if search was left unfinished
                if (!value) {
                    setInputValue("");
                } else {
                    const found = options?.find(opt => {
                        const val = valueKey === "json" ? JSON.stringify(opt) : (valueKey ? opt[valueKey] : opt);
                        return String(val) === String(value);
                    });
                    if (found) {
                        setInputValue(labelKey ? found[labelKey] : found);
                    } else {
                        try {
                            if (typeof value === "string" && value.startsWith("{")) {
                                const parsed = JSON.parse(value);
                                if (labelKey && parsed[labelKey]) {
                                    setInputValue(parsed[labelKey]);
                                    return;
                                }
                            }
                        } catch (e) {}
                        setInputValue(value);
                    }
                }
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [value, options, labelKey, valueKey]);

    const handleSelect = (option) => {
        if (disabled) return;
        const val = valueKey === "json" ? JSON.stringify(option) : (valueKey ? option[valueKey] : option);
        onChange({ target: { value: val } });
        setIsOpen(false);
    };

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
        setIsOpen(true);
    };

    const handleFocus = () => {
        setIsOpen(true);
    };

    // Filter options based on input value
    const filteredOptions = useMemo(() => {
        if (!options) return [];
        if (!inputValue) return options;
        
        // If the input value matches the currently selected option, do not filter (or filter if they type more)
        const foundLabel = options.find(opt => {
            const val = valueKey === "json" ? JSON.stringify(opt) : (valueKey ? opt[valueKey] : opt);
            return String(val) === String(value);
        });
        const selectedStr = foundLabel ? (labelKey ? foundLabel[labelKey] : foundLabel) : "";
        if (inputValue === selectedStr) return options;

        return options.filter(opt => {
            const label = labelKey ? opt[labelKey] : opt;
            return String(label || "").toLowerCase().includes(inputValue.toLowerCase());
        });
    }, [options, inputValue, labelKey, valueKey, value]);

    const hasValue = !!value;

    return (
        <div 
            ref={dropdownRef} 
            className={`${dropdowncss.customSelectWrapper} ${disabled ? dropdowncss.disabledSelect : ""}`}
        >
            <div 
                className={`${dropdowncss.customSelectTrigger} ${!hasValue ? dropdowncss.customSelectPlaceholder : ""}`}
                onClick={() => !disabled && setIsOpen(true)}
            >
                <input
                    ref={inputRef}
                    type="text"
                    placeholder={placeholder}
                    value={inputValue}
                    onChange={handleInputChange}
                    onFocus={handleFocus}
                    disabled={disabled}
                    style={{
                        border: "none",
                        outline: "none",
                        background: "transparent",
                        width: "100%",
                        fontSize: "12.5px",
                        color: "#111111",
                        padding: 0,
                    }}
                />
                <span className={dropdowncss.customSelectArrow}>
                    {isOpen ? <UpIcon width={10} height={6} style={{ color: "#2D8861" }} /> : <DownIcon width={10} height={6} style={{ color: "#2D8861" }} />}
                </span>
            </div>
            {isOpen && (
                <div className={dropdowncss.customSelectOptionsContainer}>
                    {filteredOptions.length > 0 ? (
                        filteredOptions.map((opt, idx) => {
                            const val = valueKey === "json" ? JSON.stringify(opt) : (valueKey ? opt[valueKey] : opt);
                            const label = labelKey ? opt[labelKey] : opt;
                            const isSelected = String(val) === String(value);

                            return (
                                <div 
                                    key={idx}
                                    className={`${dropdowncss.customSelectOption} ${isSelected ? dropdowncss.active : ""}`}
                                    onClick={() => handleSelect(opt)}
                                >
                                    {label}
                                </div>
                            );
                        })
                    ) : (
                        <div style={{ padding: "8px 10px", fontSize: "12.5px", color: "#b3c0bd", textAlign: "center" }}>
                            No options found
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

const TbMultiSelect = ({ show, onClose, groupings, selectedLedgers, bookClosureTbId }) => {

    const dispatch = useDispatch();

    const [menu, setMenu] = useState(true);
    const [selectedFs, setSelectedFs] = useState("");
    const [selectedNoteGroup, setSelectedNoteGroup] = useState("");
    const [selectedSubGroup, setSelectedSubGroup] = useState("");
    const [newSubGroupName, setNewSubGroupName] = useState("");
    const [groupingOptions, setGroupingOptions] = useState([]);
    const [showAddLevel3Modal, setShowAddLevel3Modal] = useState(false);
    const [newLevel3Name, setNewLevel3Name] = useState("");



    useEffect(() => {
        const mapped = groupings.map((lvl1) => ({
            fs_grp: lvl1.name,
            notes: lvl1.subgroup.map((lvl2) => ({
                note_grp: lvl2.name,
                sub: lvl2.subgroup.map((lvl3) => lvl3.name),
            })),
        }));
        setGroupingOptions(mapped);
    }, [groupings]);

    useEffect(() => {
        setSelectedNoteGroup("");
        setSelectedSubGroup("");
    }, [selectedFs]);

    useEffect(() => {
        setSelectedSubGroup("");
    }, [selectedNoteGroup]);


    const handleGroupData = (level) => {
        if (level === "fs_grp") {
            return groupingOptions.map((o) => o.fs_grp);
        }

        if (!selectedFs) return [];

        const fsObj = groupingOptions.find((o) => o.fs_grp === selectedFs);
        if (!fsObj) return [];

        if (level === "note_grp") return fsObj.notes;
        if (level === "sub_grp") {
            const noteObj = fsObj.notes.find(
                (n) => n.note_grp === selectedNoteGroup?.note_grp
            );
            return noteObj?.sub || [];
        }

        return [];
    };


    const handleMapLedgers = async () => {
        if (!selectedFs || !selectedNoteGroup || !selectedSubGroup) return;

        const payload = {
            ledgers: selectedLedgers.map((ledger) => ({
                ledgerID: ledger._id,
                FSGroupCY: selectedFs,
                notesGroupCY: selectedNoteGroup.note_grp,
                subGroupCY: selectedSubGroup,
                FSGroupPY: selectedFs, // optional if needed
                notesGroupPY: selectedNoteGroup.note_grp,
                subGroupPY: selectedSubGroup,
            })),
        };

        try {
            const response = await mapLedger(bookClosureTbId, payload);

            dispatch(updateGroupings(response.data.updatedGroupings));
            dispatch(updateLedgers(response.data.updatedLedgers));
            console.log("Mapping successful:", payload);
            onClose();
        } catch (err) {
            console.error("Failed to map ledgers:", err);
        }
    };

    if (!show) return null;

    const handleAddLevel3 = () => {

        if (!selectedFs || !selectedNoteGroup) {
            
            swal("Please select Level 1 and Level 2 first", "", "warning");
            // alert("Please select Level 1 and Level 2 first.");
            return;
        }
        setShowAddLevel3Modal(true);
    };

    const handleSaveLevel3 = async () => {
        if (!newLevel3Name.trim()) return;

        const payload = {
            level: 3,
            levelOneName: selectedFs, // Level 1
            levelTwoName: selectedNoteGroup?.note_grp || selectedNoteGroup, // Level 2
            name: newLevel3Name, // Level 3 input
        };

        try {
            // Call your backend API
            const response = await addTBNote(bookClosureTbId,payload);
            dispatch(updateGroupings(response.data.updatedGroupings));

            // const updatedGrouping = [...groupingOptions];
            // const fsObj = updatedGrouping.find((o) => o.fs_grp === selectedFs);
            // if (fsObj) {
            //     const noteObj = fsObj.notes.find(
            //         (n) => n.note_grp === selectedNoteGroup?.note_grp || selectedNoteGroup
            //     );
            //     if (noteObj) noteObj.sub.push(newLevel3Name);
            // }

            setShowAddLevel3Modal(false);
            setNewLevel3Name("");
        } catch (err) {
            console.error("Failed to add Level 3:", err);
        }
    };




    return (
        <div className={dropdowncss.multiDropdownDiv}>
            <div className={dropdowncss.multiDropdownHead}>
                <span>Multi select Menu</span>
                <span className={commoncss.dFlex} style={{ gap: "10px" }}>
                    {(selectedFs && selectedNoteGroup && selectedSubGroup) && (
                        <CircleCheckIcon className={commoncss.clickable} onClick={handleMapLedgers} />
                    )}
                    {menu ? (
                        <DownIcon
                            className={commoncss.clickable}
                            onClick={() => setMenu(!menu)}
                        />
                    ) : (
                        <UpIcon
                            className={commoncss.clickable}
                            onClick={() => setMenu(!menu)}
                        />
                    )}
                    <CloseIcon
                        width={18}
                        height={18}
                        className={commoncss.clickable}
                        onClick={onClose}
                    />
                </span>
            </div>

            {menu && (
                <motion.div
                    className={dropdowncss.multiSelectBody}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                >
                    <CustomSelect
                        value={selectedFs}
                        onChange={(e) => setSelectedFs(e.target.value)}
                        placeholder="Select FS Grouping"
                        options={handleGroupData("fs_grp")}
                    />

                    <CustomSelect
                        value={selectedNoteGroup ? JSON.stringify(selectedNoteGroup) : ""}
                        onChange={(e) => setSelectedNoteGroup(e.target.value ? JSON.parse(e.target.value) : "")}
                        placeholder="Select Notes Grouping"
                        options={handleGroupData("note_grp")}
                        disabled={!selectedFs}
                        valueKey="json"
                        labelKey="note_grp"
                    />

                    <CustomSelect
                        value={selectedSubGroup}
                        onChange={(e) => setSelectedSubGroup(e.target.value)}
                        placeholder="Select Sub Grouping"
                        options={handleGroupData("sub_grp")}
                        disabled={!selectedNoteGroup}
                    />


                    {/* Add Level 3 */}
                    {selectedFs && selectedNoteGroup && (
                        <div className={commoncss.dFlex} style={{ gap: "5px", marginTop: "10px",justifyContent:"center" }}>
                            <div
                                className={`${commoncss.clickable} ${commoncss.dFlex} ${commoncss.fs14}`}
                                style={{ placeSelf: "center", color: "#2D8861" }}
                                onClick={handleAddLevel3}
                            >
                                <PlusIcon />&nbsp;Add Sub Grouping
                            </div>
                        </div>
                    )}
                </motion.div>
            )}
            {showAddLevel3Modal && (
                <Modal
                    title="Add Sub Group (Level 3)"
                    bodycss={commoncss.unsetPadding}
                    headerActions={
                        <CloseIcon
                            onClick={() => setShowAddLevel3Modal(false)} Name="clickable"
                        />
                    }
                    footerActions={
                        <>
                            <Button
                                btnColor={buttoncss.secondary}
                                onClick={() => setShowAddLevel3Modal(false)}
                                label="Cancel"
                            />
                            <Button
                                btnColor={buttoncss.primary}
                                label="Save"
                                onClick={handleSaveLevel3}
                            />
                        </>
                    }
                >
                    <div className={commoncss.pd1530}>
                        <InputGroup
                            label="Sub Grouping Name"
                            inputs={[
                                <>
                                    <input
                                        type="text"
                                        placeholder="Enter Sub Group name"
                                        value={newLevel3Name}
                                        onChange={(e) => setNewLevel3Name(e.target.value)}
                                    />
                                </>,
                            ]}
                        />
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default TbMultiSelect;
